import React,{useContext} from 'react'
import { Container, Row, Col } from 'reactstrap'
import Form from '../Form/Form'
import {themeContext} from '../../Context'


import './Contact.css'
const Contact = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    return <section id='contact' className='mb-5'>
        <Container>
            <Row>
                <Col lg='12' className="mb-5">
                    <h2> Contact me! </h2>
                </Col>
                <Col lg='4' md='4'>
                    <div className="contact_info-container d-flex flex-wrap align-items-center gap-3">
                        <div className={`single_info-box w-100 ${darkMode ? 'single_info-box-dark':'single_info-box-light'}`}>
                            <h6> Address </h6>
                            <p> Telangana, India </p>
                        </div>
                        <div className={`single_info-box w-100 ${darkMode ? 'single_info-box-dark':'single_info-box-light'}`}>
                            <h6> Phone </h6>
                            <p> +91-8106490463 </p>
                        </div>
                        <div className={`single_info-box w-100 ${darkMode ? 'single_info-box-dark':'single_info-box-light'}`}>
                            <h6> Email </h6>
                            <p><a href='mailTo: mogilicherlashashikanth@gmail.com' style={{textDecoration:'none'}}> mogilicherlashashikanth@gmail.com </a></p>
                        </div>
                        <div className={`single_info-box w-100 ${darkMode ? 'single_info-box-dark':'single_info-box-light'}`}>
                            <h6> Location </h6>
                            <p> Shivanagar, Warangal, Telangana, India </p>
                        </div>
                    </div>
                </Col>
                <Col lg='8' md='8'>
                    <Form/>
                </Col>
            </Row>
        </Container>
    </section >

}

export default Contact